<template>
    <div class="engineering">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="selectExportBtn()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="engineerList"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column label="名称" prop="name" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="预计成本" prop="expectCostPrice" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="预计成本（填写金额）" prop="expectCostPriceManual" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="占比" prop="expectRate" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="预计成本（填写金额）占比" prop="expectRateManual" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="实际成本" prop="actCostPrice" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="实际成本（填写金额）" prop="actCostPriceManual" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="占比" prop="actRate" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="实际成本（填写金额）占比" prop="actRateManual" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.name != '合计'" @click="handleModifyClick(scope.row)" type="text" size="small">设置填写金额</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
        </el-container>

        <el-dialog
            title="设置填写金额"
            :visible.sync="isShowModifyDialog"
            width="40%"
            :before-close="handleClose">
            <el-form ref="form" :model="form" label-width="200px">
                <el-form-item label="预计成本（填写金额）">
                    <el-input v-model="form.estimate" @input="changeEstimate($event)"></el-input>
                </el-form-item>
                <el-form-item label="实际成本（填写金额）">
                    <el-input v-model="form.actual" @input="changeActual($event)"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="info" @click="cancellation">取 消</el-button>
                <el-button type="primary" @click="modifyNumber">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="导出"
                :visible.sync="isShowExportDialog"
                width="30%"
                :before-close="handleExportClose">
            <el-radio v-model="radio" label="1">金额</el-radio>
            <el-radio v-model="radio" label="2">填写金额</el-radio>
            <span slot="footer">
                <el-button type="info" @click="cancellationExport">取 消</el-button>
                <el-button type="primary" @click="defineExport">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getDeptListService,
        getProjectListService,
    } from '@/services/invoiceServices'
    import {
        getCostAnalysisTableService,
        costAnalysisTableService,
        setCostAnalysisTableService,
    } from "../../services/engineering";
    import {exportExcelService2} from "../../services/allContractServices";
    export default {
        name: "expenditureStatistics",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                deptList:[], //项目部列表
                projectList:[], //项目列表
                engineerList: [],
                btnAuthorize: {
                    export: { key: "export", btnEnable: false }
                },

                isShowModifyDialog: false,
                form: {
                    estimate: "",
                    reality: "",
                },
                selectItem: null,

                isShowExportDialog: false,
                radio: '1',
            }
        },
        methods: {
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getDeptList();
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            query(){
                let paramsData = {
                    ...this.dataForm
                }
                getCostAnalysisTableService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.engineerList = [{
                            name: '劳务',
                            actCostPrice: res.data.laborVO.actCostPrice,
                            actCostPriceManual: res.data.laborVO.actCostPriceManual,
                            actRate: res.data.laborVO.actRate,
                            actRateManual: res.data.laborVO.actRateManual,
                            expectCostPrice: res.data.laborVO.expectCostPrice,
                            expectCostPriceManual: res.data.laborVO.expectCostPriceManual,
                            expectRate: res.data.laborVO.expectRate,
                            expectRateManual: res.data.laborVO.expectRateManual,
                            estimate: 'expectCostPriceLabor',
                            actual:'actCostPriceLabor'
                        },{
                            name: '机械',
                            actCostPrice: res.data.machineVO.actCostPrice,
                            actCostPriceManual: res.data.machineVO.actCostPriceManual,
                            actRate: res.data.machineVO.actRate,
                            actRateManual: res.data.machineVO.actRateManual,
                            expectCostPrice: res.data.machineVO.expectCostPrice,
                            expectCostPriceManual: res.data.machineVO.expectCostPriceManual,
                            expectRate: res.data.machineVO.expectRate,
                            expectRateManual: res.data.machineVO.expectRateManual,
                            estimate: 'expectCostPriceMachine',
                            actual:'actCostPriceMachine'
                        },{
                            name: '材料',
                            actCostPrice: res.data.materialVO.actCostPrice,
                            actCostPriceManual: res.data.materialVO.actCostPriceManual,
                            actRate: res.data.materialVO.actRate,
                            actRateManual: res.data.materialVO.actRateManual,
                            expectCostPrice: res.data.materialVO.expectCostPrice,
                            expectCostPriceManual: res.data.materialVO.expectCostPriceManual,
                            expectRate: res.data.materialVO.expectRate,
                            expectRateManual: res.data.materialVO.expectRateManual,
                            estimate: 'expectCostPriceMaterial',
                            actual:'actCostPriceMaterial'
                        },{
                            name: '其他',
                            actCostPrice: res.data.otherVO.actCostPrice,
                            actCostPriceManual: res.data.otherVO.actCostPriceManual,
                            actRate: res.data.otherVO.actRate,
                            actRateManual: res.data.otherVO.actRateManual,
                            expectCostPrice: res.data.otherVO.expectCostPrice,
                            expectCostPriceManual: res.data.otherVO.expectCostPriceManual,
                            expectRate: res.data.otherVO.expectRate,
                            expectRateManual: res.data.otherVO.expectRateManual,
                            estimate: 'expectCostPriceOthers',
                            actual:'actCostPriceOthers'
                        },{
                            name: '合计',
                            actCostPrice: res.data.totalVO.actCostPrice,
                            actCostPriceManual: res.data.totalVO.actCostPriceManual,
                            actRate: res.data.totalVO.actRate,
                            actRateManual: res.data.totalVO.actRateManual,
                            expectCostPrice: res.data.totalVO.expectCostPrice,
                            expectCostPriceManual: res.data.totalVO.expectCostPriceManual,
                            expectRate: res.data.totalVO.expectRate,
                            expectRateManual: res.data.totalVO.expectRateManual,
                        },];
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.projectList = [];
                this.engineerList = [];
                this. dataForm = {
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                };
            },
            selectExportBtn() {
                this.isShowExportDialog = true;
            },
            exportBtn(bool){
                let params = {
                    ...this.dataForm,
                    isManualValue: bool,
                }
                costAnalysisTableService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },

            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        this.cancellation();
                        done();
                    })
                    .catch(_ => {});
            },
            handleModifyClick(item) {
                this.selectItem = item;
                this.isShowModifyDialog = true;
            },
            modifyNumber() {
                if (!this.form.estimate) {
                    this.$message.error("请输入预计成本（填写金额）！");
                    return
                }
                if (!this.form.actual) {
                    this.$message.error("请输入实际成本（填写金额）！");
                    return
                }
                let params = {
                    projectId: this.dataForm.projectId,
                }
                params[this.selectItem.estimate] = this.form.estimate;
                params[this.selectItem.actual] = this.form.actual;
                setCostAnalysisTableService(params).then( res => {
                    if(res.code == 10000000){
                        this.query();
                        this.cancellation();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            cancellation() {
                this.form.estimate = '';
                this.form.actual = '';
                this.selectItem = null;
                this.isShowModifyDialog = false;
            },

            handleExportClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        this.cancellationExport();
                        done();
                    })
                    .catch(_ => {});
            },
            defineExport() {
                this.isShowExportDialog = false;
                this.exportBtn(this.radio == 2?true: false)
            },
            cancellationExport() {
                this.isShowExportDialog = false;
            },

            changeEstimate(value) {
                if (!value) {
                    return
                }
                let val = (value && value.split("")) || [];
                this.form.estimate = val.join("").match(/^[0-9]\d*(\.?\d{0,2})/g)?val.join("").match(/^[0-9]\d*(\.?\d{0,2})/g)[0]: null || null;
            },

            changeActual(value) {
                if (!value) {
                    return
                }
                let val = (value && value.split("")) || [];
                this.form.actual = val.join("").match(/^[0-9]\d*(\.?\d{0,2})/g)?val.join("").match(/^[0-9]\d*(\.?\d{0,2})/g)[0]: null || null;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
    }
</style>
